import { Vocational } from '@lemsar/common/domains/models/vocational';
import { Institution } from '@lemsar/institution/domains/model/institution';
import { EquipmentGallery } from '@lemsar/institution/domains/model/building';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    02/09/2018
 */
export class Equipment {
    public id: string;
    public vocational: Vocational;
    public equipmentCategory: EquipmentCategory;
    public name: string;
    public minTotal: number;
    public unit: string;
}

export class EquipmentCategory {
    public id: string;
    public name: string;
}

export class EquipmentInstitution {
    public id: string;
    public institution: Institution;
    public equipment: Equipment;
    public total: number;
    public unit: string;
    public condition: string;
    public pictures?: EquipmentGallery;
}



// WEBPACK FOOTER //
// ./src/lemsar/institution/domains/model/equipment.ts